import React, { useCallback, useState } from 'react'
import { Form } from 'react-bootstrap'

const nameRegEx = /^[-a-zA-Zа-яА-Я\s]*$/

interface INameInputProps {
  defaultValue?: string
  onChange: (value: string) => void
  style?: React.CSSProperties
}

const NameInput: React.FC<INameInputProps> = ({ defaultValue, onChange, style }) => {
  const [value, setValue] = useState<string>(defaultValue || '')
  const [isValid, setIsValid] = useState(false)

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value
      const resultValue = value.trim()
      const isValid_ = nameRegEx.test(resultValue) && resultValue.length > 3

      setIsValid(isValid_)
      onChange(isValid_ ? resultValue : '')
      setValue(value)
    },
    [onChange]
  )

  return (
    <Form.Group className={'mb-3'}>
      <Form.Label>Введите имя</Form.Label>
      <Form.Control
        value={value}
        type='text'
        placeholder='Ваше имя'
        maxLength={50}
        onChange={handleChange}
        style={style}
        className={isValid ? 'is-valid' : 'is-invalid'}
      />
      <div className='invalid-feedback' style={{ display: isValid ? 'none' : 'block' }}>
        {value.trim().length < 4
          ? 'Поле должно содержать не менее 4 символов'
          : 'Поле может содержать латинские и русские буквы, дефис, пробел'}
      </div>
    </Form.Group>
  )
}
export default NameInput
